import { __rest } from "tslib";
import React from 'react';
import { PennyMacContext } from './PnmacContext.js';
import PnmacText from '../Typography/PnmacText';
import { View, TouchableOpacity } from 'react-native';
import styles from './PnmacContext.styles.js';
function PnmacContextConsumer(props) {
  return /*#__PURE__*/React.createElement(PennyMacContext.Consumer, null, function (_a) {
    var translations = _a.translations,
      toggleTheme = _a.toggleTheme,
      theme = __rest(_a, ["translations", "toggleTheme"]);
    //console.log("Theme Provider", theme)
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: function () {
        return toggleTheme();
      }
    }, /*#__PURE__*/React.createElement(PnmacText, null, props.title || translations.themeSwitcher));
  });
}
export default PnmacContextConsumer;